"use client";
import Link from 'next/link';

export default function NotFound() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f3f4f6', textAlign: 'center', padding: '2rem', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      
      <div style={{ background: 'white', padding: '3rem 4rem', borderRadius: '1.5rem', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '500px', width: '100%' }}>
        
        {/* Animated Icon */}
        <div style={{ color: '#1c7bff', marginBottom: '1.5rem' }}>
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
               style={{ animation: 'bounce 2s infinite' }}>
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M16 16s-1.5-2-4-2-4 2-4 2"></path>
            <line x1="9" y1="9" x2="9.01" y2="9"></line>
            <line x1="15" y1="9" x2="15.01" y2="9"></line>
          </svg>
          <style>{`
            @keyframes bounce {
              0%, 100% { transform: translateY(-5%); animation-timing-function: cubic-bezier(0.8,0,1,1); }
              50% { transform: translateY(0); animation-timing-function: cubic-bezier(0,0,0.2,1); }
            }
            .back-btn:hover {
              background-color: #1562cc !important;
              transform: translateY(-2px);
              box-shadow: 0 10px 15px -3px rgba(28, 123, 255, 0.3), 0 4px 6px -2px rgba(28, 123, 255, 0.15) !important;
            }
          `}</style>
        </div>

        <h1 style={{ fontSize: '6rem', fontWeight: 800, color: '#111827', margin: '0 0 0.5rem 0', lineHeight: 1, letterSpacing: '-0.02em' }}>
          404
        </h1>
        
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, color: '#374151', margin: '0 0 1rem 0' }}>
          Page Not Found
        </h2>
        
        <p style={{ color: '#6b7280', marginBottom: '2.5rem', fontSize: '1.05rem', lineHeight: 1.5, maxWidth: '350px' }}>
          Oops! The page you are looking for doesn't exist, has been moved, or you don't have access to it.
        </p>

        <Link href="/en" className="back-btn" style={{ 
          background: '#1c7bff', 
          color: 'white', 
          padding: '0.875rem 2rem', 
          borderRadius: '9999px', 
          textDecoration: 'none', 
          fontWeight: 600,
          fontSize: '1rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          transition: 'all 0.2s ease-in-out',
          boxShadow: '0 4px 6px -1px rgba(28, 123, 255, 0.2), 0 2px 4px -1px rgba(28, 123, 255, 0.1)'
        }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Return to Homepage
        </Link>
      </div>
      
    </div>
  );
}
